export default __webpack_public_path__ + "static/media/4_manufatura.981d7932.webp";